window.slurrpitupRegistration = {}

class SlurrpItUpQuizContainer extends HTMLElement {
  constructor() {
    super();
    this.initButtons()
  }

  connectedCallback() {
    if (this._sliderInitialized) return;
    this.initQuizSlider();
    this._sliderInitialized = true;
  }

  initQuizSlider() {
    if (typeof Splide === 'undefined') return;
    this.sliderElement = this.querySelector('.quiz-slider__container')
    this.slider = new Splide( this.sliderElement, {
      type: 'fade',
      perPage: 1,
      pagination: false,
      arrows: false,
      drag : false,
    });

    const carousel = this.slider
    const bar = this.querySelectorAll('.progress-bar__inner').forEach((eachBar) => {
      carousel.on('mounted move', function () {
        var end = carousel.Components.Controller.getEnd() - 1 ;
        var rate = Math.min((carousel.index) / end, 1);
        eachBar.style.width = String(100 * rate) + '%';
      });
    })

    this.slider.mount();

    this.slurrpitupCustomer = this.getAttribute('data-slurrpitup-customer');
    this.firstPage = this.getAttribute('data-first-page');

    if (this.slurrpitupCustomer == 'true') {
      const totalSlides = this.slider.length;
      this.slider.go(totalSlides - 1);
    }
  }

  initButtons() {
    // init custom next and prev buttons for the slider
    this.querySelector('.splide__arrow.quiz_arrow--prev').addEventListener('click', ()=>{
      const currentSlide = this.querySelector('.splide__slide.is-active')
      const blockType = currentSlide.dataset.blockType?.toLowerCase()
      if (blockType == "phone_number") {
        const solideFood = window.slurrpitupRegistration.solid_foods 
        if (solideFood == "No") {
          this.gotToSOlidFoodSlide()
        } else {
          this.gotToPrevSlide()
        }
      } else {
        this.gotToPrevSlide()
      }
    });
  
    this.querySelector('.splide__arrow.quiz_arrow--next').addEventListener('click', ()=>{
      this.gotToNextSlide(true);
    });

    // quiz-landing__button
    this.querySelector('.quiz-landing__button')?.addEventListener('click', (e)=>{
      this.gotToNextSlide();
      this.showButtons();
    });
  }

  showButtons() {
    this.prevButton = this.querySelector('.splide__arrow.quiz_arrow--next')
    this.nextButton = this.querySelector('.splide__arrow.quiz_arrow--prev')
    this.prevButton.classList.add('show-arrows')
    this.nextButton.classList.add('show-arrows')
  }

  hideButtons() {
    this.prevButton = this.querySelector('.splide__arrow.quiz_arrow--next')
    this.nextButton = this.querySelector('.splide__arrow.quiz_arrow--prev')
    this.prevButton.classList.remove('show-arrows')
    this.nextButton.classList.remove('show-arrows')
  }

  gotToPrevSlide() {
    const sliderIndex = this.slider.Components.Controller.getIndex()
    if (sliderIndex > 1){
      this.slider.go('-1');
    }
  }

  gotToSOlidFoodSlide() {
    this.slider.go(4);
  }

  gotToNextSlide(handleSubmit) {
    if (handleSubmit) {
      this.handleSlideSubmit();
    } else {
      this.slider.go('+1');
    }
  }

  gotToPhoneSlide() {
    const phoneSlide = this.slider.length - 2 
    this.slider.go(phoneSlide);
  }

  handleSlideSubmit() {
    const currentSlide = this.querySelector('.splide__slide.is-active')
    const blockType = currentSlide.dataset.blockType?.toLowerCase()
    switch (blockType) {
    case 'dob':
      this.handleDOBSubmit(currentSlide)
      break;
    case 'questions' || 'question':
      this.handleQuestionSubmit(currentSlide)
      break;
    case 'phone_number':
      this.handlePhoneSubmit(currentSlide)
      break;
    case 'all_questions':
      this.handleAllQuestionsSubmit(currentSlide)

    }
  }

  handleDOBSubmit(currentSlide, dobQuestionId) {
    const questionId = dobQuestionId || currentSlide.dataset.questionId 
    const customerId = currentSlide.dataset.customerId
    let date = this.querySelector('.quiz-date--input:checked')?.value
    let month = this.querySelector('input[name="month"]:checked')?.value
    let year = this.querySelector('input[name="year"]:checked')?.value

    if (date != undefined && month != undefined && year != undefined && questionId.length > 0) {
      currentSlide.querySelector('.quiz-date-of-birth__container .quiz_input--error').innerHTML = ''
      date = String(date).padStart(2, '0');
      const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      const monthNumber = monthNames.indexOf(month) + 1;
      const formattedMonthNumber = String(monthNumber).padStart(2, '0');
      month = formattedMonthNumber
      const dob = `${date}-${month}-${year}`
      window.slurrpitupRegistration['id'] = parseInt(customerId)
      window.slurrpitupRegistration[`${questionId}`] = dob

      //======================================== 
      // cleverTap event for Baby's Date Of Birth event
      // ========================================
      clevertap.event.push('Baby DOB', {
        'Name':  window.customerFullName,
        'Identity': window.customerID,
        'Email': window.customerEmail,
        'Phone': window.customerPhone,
        'DOB': new Date(dob)
      })

    } else {
      // TODO
      // commented futire purpose
      // currentSlide.querySelector('.quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step'; 
      currentSlide.querySelector('.quiz-date-of-birth__container .quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step';
    }
  }

  handleQuestionSubmit(currentSlide) {
    const questionType = currentSlide.dataset.questionType?.toLowerCase()
    switch (questionType) {
    case 'input':
      this.handleTextSubmit(currentSlide)
      break;
    case 'dropdown':
      this.handleDropdownSubmit(currentSlide)
      break;
    case 'radio':
      this.handleRadioSubmit(currentSlide)
      break;
    case 'checkbox':
      this.handleCheckboxSubmit(currentSlide)
      break;
    }
  }

  handleCheckboxSubmit(currentSlide) {
    const value = []
    currentSlide.querySelectorAll('input:checked').forEach((i)=>{
      value.push(i.value)
    })
    if (value.length > 0 && currentSlide.dataset.questionId?.length > 0) {
      currentSlide.querySelector('.quiz_input--error').innerHTML = ''
      // saving the selections as comma separated values
      slurrpitupRegistration[currentSlide.dataset.questionId] = JSON.stringify(value)
      this.gotToNextSlide()
    } else {
      // TODO
      currentSlide.querySelector('.quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step'
    }
  }

  handleTextSubmit(currentSlide, babyNameQuestionId) {
    const value = currentSlide.querySelector('input.quiz--input-field').value
    const questionId = babyNameQuestionId || currentSlide.dataset.questionId
    if (value.length > 0 && questionId?.length > 0) {
      currentSlide.querySelector('.slurrpitup-quiz__questions .quiz_input--error').innerHTML = ''
      slurrpitupRegistration[questionId] = value
    } else {
      // TODO
      // commented futire purpose
      // currentSlide.querySelector('.quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step'
      currentSlide.querySelector('.slurrpitup-quiz__questions .quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step';
    }
  }

  stripNonNumeric(inputString) {
    return inputString.replace(/\D/g, '');
  }

  handleRadioSubmit(currentSlide) {
    const value = currentSlide.querySelector('input:checked')?.value
    if (value !== undefined && currentSlide.dataset.questionId?.length > 0) {
      currentSlide.querySelector('.quiz_input--error').innerHTML = ''
      slurrpitupRegistration[currentSlide.dataset.questionId] = value
      const solideFood = window.slurrpitupRegistration.solid_foods 
      if (solideFood == "No") {
        this.gotToPhoneSlide()
      } else {
        this.gotToNextSlide()
      }
    } else {
      // TODO
      currentSlide.querySelector('.quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step'
    }
  }

  handleDropdownSubmit(currentSlide) {
    const value = currentSlide.querySelector('input:checked')?.value
    if (value != undefined && currentSlide.dataset.questionId?.length > 0) {
      currentSlide.querySelector('.quiz_input--error').innerHTML = ''
      const parsedValue = parseInt(value)
      slurrpitupRegistration[currentSlide.dataset.questionId] = parsedValue
      this.gotToNextSlide()
    } else {
      // TODO
      currentSlide.querySelector('.quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step'
    }
  }

  handlePhoneSubmit(currentSlide) {
    const value = this.querySelector('input[type="number"]')?.value
    const whatsappChecked = this.querySelector('input[name="whatsapp-message"]').checked
    const termsandConditons = this.querySelector('input[name="t_c_description"]')
    const guidelines = this.querySelector('input[name="guidelines-description"]')

    if (isValidPhoneNumber(value)) {
      currentSlide.querySelector('.quiz-phone-number__container .quiz_input--error').innerHTML = '';
      const parsedValue = parseInt(value)
      slurrpitupRegistration['phone'] = parsedValue
    } else {
      // TODO
      // currentSlide.querySelector('.quiz_input--error').innerHTML = '*Invalid phone number'
      currentSlide.querySelector('.quiz-phone-number__container .quiz_input--error').innerHTML = '*Invalid phone number';
      return
    }

    if (whatsappChecked) {
      currentSlide.querySelector('.quiz-phone-number__container .quiz_input--error').innerHTML = '';
      //this.gotToNextSlide();
      this.hideButtons();
      this.sendQuizData();

      //=================================
      // cleverTap event for Quiz completed
      //================================= 
      clevertap.event.push('Quiz Completed', {
        'Name':  window.customerFullName,
        'Identity': window.customerID,
        'Email': window.customerEmail,
        'Phone': window.customerPhone,
        'DOB': new Date(window.slurrpitupRegistration.dob)
      })
    }else{
      // currentSlide.querySelector('.quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step';
      currentSlide.querySelector('.quiz-phone-number__container .quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step';
      return
    }

    if (termsandConditons && guidelines) {
      if (termsandConditons.checked && guidelines.checked) {
        // Execute your code here that depends on both being checked
        this.hideButtons();
        this.sendQuizData();

        //=================================
        // cleverTap event for Quiz completed
        //================================= 
        clevertap.event.push('Quiz Completed', {
          'Name':  window.customerFullName,
          'Identity': window.customerID,
          'Email': window.customerEmail,
          'Phone': window.customerPhone,
          'DOB': new Date(window.slurrpitupRegistration.dob)
        })
      } else {
        // currentSlide.querySelector('.quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step'
        currentSlide.querySelector('.quiz-phone-number__container .quiz_input--error').innerHTML = '*Please fill the details above and proceed to next step';
        return
      }
    }
  }

  handleAllQuestionsSubmit() {
    const currentSlide = this.querySelector('.splide__slide.is-active');
    const questionId_1 = currentSlide.getAttribute('data-question-id-1');
    const questionId_2 = currentSlide.getAttribute('data-question-id-2');
    const questionId_3 = currentSlide.getAttribute('data-question-id-3');

    this.handleTextSubmit(currentSlide, questionId_2)
    this.handleDOBSubmit(currentSlide, questionId_1)
    this.handlePhoneSubmit(currentSlide, questionId_3)
  }
  sendQuizData() {
    const postData = window.slurrpitupRegistration

    // URL for the POST request
    const url = 'https://marmeto.wholsumfoods.com/api/quiz';

    // Configuration for the fetch request
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json' // Specify content type as JSON
      },
      body: JSON.stringify(postData) // Convert the data to JSON format
    };

    // Make the POST request
    fetch(url, requestOptions)
      .then(response => {
        if(response.status == 406){
          window.location = "https://slurrpfarm.com/pages/slurrp-it-up-landing-page-above-12-months"
        }
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json(); // Parse the JSON in the response
      })
      .then(data => {
        console.log('Success:', data);
        // Handle the response data here
        
        setTimeout(() => {
          if (data.age < 121) {
            window.location = "https://slurrpfarm.com/pages/slurrpitup-articles-below-5-months"
          } else if (data.age >= 121 && data.age <= 360) {
            this.articleRedirection(data.age);
          } else {
            window.location = "https://slurrpfarm.com/pages/slurrp-it-up-landing-page-above-12-months"
          }
        }, 1000);
      })
      .catch(error => {
        console.error('Error:', error);
        // Handle errors here
      });

  }

  articleRedirection(age) {
    const url = `https://slurrpfarm.com/blogs/slurrp-it-up/tagged/age_${age}`
    fetch(url)
    .then((response) => response.text())
    .then((data) => {
      // Process the retrieved article
      let newDoc = new DOMParser().parseFromString(data, "text/html");
      const newBlogsList = newDoc.querySelector('.blog-articles__list')
      const articleCard = newBlogsList.querySelector('.articles-card_wrapper')
      if (articleCard) {
        const articleUrl = articleCard.querySelector('.article-link__wrapper').href
        window.location = articleUrl
      } else {
        window.location = "https://slurrpfarm.com/pages/slurrpitup-landing-page-5-12-months"
      }
    })
    .catch(error => {
      console.error('Error:', error);
      // Handle errors here
      window.location = "https://slurrpfarm.com/pages/slurrpitup-landing-page-5-12-months"
    });
  }

}

customElements.define('slurrpitup-container', SlurrpItUpQuizContainer)

class CustomDropDown extends HTMLElement {
  constructor() {
    super();
    this.init()
  }

  init() {
    this.querySelector('.show-dropdown__button')?.addEventListener('click', (event)=>{
      this.showDropdownOptions(event)
    })

    this.querySelector('.close-dropdown-options')?.addEventListener('click', ()=>{
      this.hideDropdownOptions()
    })

    this.addEventListener('change', (event)=>{
      this.handleOnValueChange(event)
    })
    this.bodyClickClose();
  }

  showDropdownOptions(event) {
    document.querySelectorAll('.quiz__drop-down').forEach((each)=> each.classList.remove('active'));
    this.querySelector('.quiz__drop-down').classList.add('active');
    document.querySelector('.splide__track').classList.add('show-overlay') 
  }

  hideDropdownOptions() {
    this.querySelector('.quiz__drop-down').classList.remove('active');
    document.querySelector('.splide__track').classList.remove('show-overlay') 
    
  }

  handleOnValueChange(event) {
    this.querySelector('.selected--value').innerHTML = event.target.value;
    this.suffix = this.querySelector('.selected-value-suffix')
    if (this.suffix) {
      const suffixValue = event.target.dataset.suffix
      this.suffix.innerHTML = suffixValue
    }
    this.hideDropdownOptions()
    this.querySelector('.select-date').classList.add('hide-element');
  }

  bodyClickClose() {
    window.onclick = function (event) {
      if (!event.target.closest('.quiz__drop-down') && !event.target.closest('.show-dropdown__button') && !event.target.closest('.mm-ajaxcart-open') && !event.target.closest('.mm-ajaxcart') && !event.target.closest('.slide-container')) {
        document.querySelectorAll('.quiz__drop-down').forEach(function (e) {
          e.classList.remove('active');
          document.querySelector('.splide__track').classList.remove('show-overlay') 
        })
      }
    }
  }
}

customElements.define('custom-dropdown', CustomDropDown)

function isValidPhoneNumber(phoneNumber) {
 // Define a regular expression for a phone number with a maximum length of 10 digits
 const phoneRegex = /^\d{10}$/;

 // Test if the provided phone number matches the regex
 return phoneRegex.test(phoneNumber);
}
